import type { RouteRecordRaw } from 'vue-router';

export const usersRoute: RouteRecordRaw = {
  path: '/users',
  name: 'Users',
  component: () => import('./pages/UsersPage.vue'),
  meta: {
    layout: 'main',
    // The Users page is an admin surface (create/update/delete/roles), so it is
    // gated on an admin-only action.
    //
    // Deliberately NOT `users:list`: AGENT holds that too, for the assignee
    // picker on a ticket. Gating this page on it would hand the whole user
    // administration screen to every support agent — the exact boundary the
    // AGENT role exists to draw.
    authorize: ({ isGranted }) => isGranted('st:core:users:create'),
  },
};

export const userDetailRoute: RouteRecordRaw = {
  path: '/users/:id',
  name: 'UserDetail',
  component: () => import('./pages/UserPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('st:core:users:get'),
  },
};
